import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

import CookieAgreementDialog from './cookie-agreement-dialog'
import CookieAgreementLink from './cookie-agreement-link'
import CookieAgreementSlide from './cookie-agreement-slide'
import useCookieAgreementCountry from './use-cookie-agreement-country'

export default function CookieAgreement() {
  const [cookies, setCookie, deleteCookie] = useCookies()
  const cookieAgreementCountry = useCookieAgreementCountry()

  const [isSlideIn, setIsSlideIn] = useState<boolean>(false)
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

  const handleSlide = (isIn: boolean) => {
    setIsSlideIn(isIn)
  }

  const handleDialog = (isOpen: boolean) => {
    setIsDialogOpen(isOpen)
  }

  const handleSaEnableCookie = (isOn: boolean) => {
    setCookie('sa_enable', isOn ? 'on' : 'off')
  }

  useEffect(() => {
    if (cookieAgreementCountry === 'UNDEFINED') return
    if (cookieAgreementCountry === 'OTHER') {
      deleteCookie('sa_enable')
      handleSlide(false)
      handleDialog(false)
    } else if (cookies.sa_enable === undefined || cookies.sa_enable === '') {
      setCookie('sa_enable', '')
      handleSlide(true)
    }
  }, [cookieAgreementCountry])

  return (
    <>
      <CookieAgreementLink />
      <CookieAgreementSlide
        cookieAgreementCountry={cookieAgreementCountry}
        isSlideIn={isSlideIn}
        isDialogOpen={isDialogOpen}
        handleSlide={handleSlide}
        handleDialog={handleDialog}
        handleSaEnableCookie={handleSaEnableCookie}
      />
      <CookieAgreementDialog
        isDialogOpen={isDialogOpen}
        handleSlide={handleSlide}
        handleDialog={handleDialog}
        handleSaEnableCookie={handleSaEnableCookie}
      />
    </>
  )
}
